module.exports = __webpack_public_path__ + "static/media/multisiectIconPart.5e3d3f08.svg";